import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './simulatedActions';

export const getEvaluations = apiTask(
  actions.GET_EVALUATIONS,
  api.post,
  '/evaluation-system/getEvaluations.php',
);

export const getGroupsTask = watchApiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);

export function* wathGetEvaluations() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATIONS);
    yield fork(getEvaluations, payload);
  }
}

export const getEvaluationInformation = apiTask(
  actions.GET_EVALUATION_INFORMATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);
export function* wathGetEvaluationInformation() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATION_INFORMATION);
    yield fork(getEvaluationInformation, payload);
  }
}

export const getEvaluationSteps = apiTask(
  actions.GET_EVALUATION_STEPS,
  api.post,
  '/evaluation-system/getEvaluationsSteps.php',
);
export function* wathGetEvaluationSteps() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATION_STEPS);
    yield fork(getEvaluationSteps, payload);
  }
}

export const removeContentmapAbilities = apiTask(
  actions.REMOVE_CONTENTMAP_ABILITIES,
  api.post,
  '/evaluation-system/removeContentmapAbilities.php',
);
export function* wathRemoveContentmapAbilities() {
  while (true) {
    const { payload } = yield take(actions.REMOVE_CONTENTMAP_ABILITIES);
    yield fork(removeContentmapAbilities, payload);
  }
}

export const changeTeacherEdit = apiTask(
  actions.CHANGE_TEACHER_EDIT,
  api.post,
  '/evaluation-system/changeTeacherEdit.php',
);
export function* watchChangeTeacherEdit() {
  while (true) {
    const { payload } = yield take(actions.CHANGE_TEACHER_EDIT);
    yield fork(changeTeacherEdit, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([
    fork(wathGetEvaluations),
    fork(wathGetEvaluationInformation),
    fork(wathGetEvaluationSteps),
    fork(wathRemoveContentmapAbilities),
    fork(watchChangeTeacherEdit),
    fork(getGroupsTask),
  ]);
}
